import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import Select from 'react-select';
import * as campaignActions from "../../redux/Campaign/actions";

const SelectCampaign = props => {
	const { selectedVendor, onSelectContactCampaign } = props;
	const dispatch = useDispatch();
	const campaigns = useSelector(state => state.campaign).campaigns;

	useEffect(() => {
		const load = async () => {
			await dispatch(campaignActions.loadCampaigns([]));
		};
		load();
	}, []);

	if(!campaigns) {
		return <div/>;
	}

	let options = campaigns
		.filter(c => c.vendor === selectedVendor)
		.sort((a,b) => a.campaign_name.localeCompare(b.campaign_name))
		.map(c => ({ value: c.campaign_id, label: `${c.campaign_id} - ${c.campaign_name}` }));

	// options.unshift({ value: '-1', label: '' });

	return (
		<div style={{width: '650px', textAlign: 'left'}}>
			<Select
				// isMulti
				styles={{
					control: (baseStyles, state) => ({
						...baseStyles,
						border: '1px solid #D3E1ED !important',
						borderShadow: '0px 0px 0px 0px transparent',
						borderRadius: '20px',
						backgroundColor: 'transparent',
						paddingLeft: '5px',
						outline: 'none'
					}),
					menuList: (provided) => ({
						...provided,
						maxHeight: '280px' // Set your desired max height
					})
				}}
				onChange={onSelectContactCampaign}
				options={options}
				// closeMenuOnSelect={false}
				// blurInputOnSelect={false}
			/>
		</div>
	)
};

export default SelectCampaign;